import styles from './NutriBot.module.css';
import 'react-chat-elements/dist/main.css';
import { getAnswer } from '../services/NutriBotServices';
import React, { useState, useEffect } from 'react';
import { MessageList } from 'react-chat-elements';
import { Button, Input, Space, Layout, Tooltip, Typography, Image } from 'antd';
import { DeleteOutlined, SendOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { TextArea } = Input;
const { Title } = Typography;
let insertTextPlaceholder, userAvatar, botAvatar;

const defaultErrorAnswer = 'Impossível obter uma resposta, por favor tente mais tarde.';

fetch('data/nutribot/text.json')
  .then((response) => response.json())
  .then((json) => {
    ({ insertTextPlaceholder } = json.pages.NutriBot.text);
    ({ botAvatar, userAvatar } = json.images);
  })
  .catch((error) => {
    console.log('fetch data failed', error);
  });

const NutriBot = () => {
  const [messages, setMessages] = useState(() => {
    const savedMessages = localStorage.getItem('botMessages');
    return savedMessages ? JSON.parse(savedMessages) : [];
  });
  const [inputMessage, setInputMessage] = useState('');
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  let messageListReferance = React.createRef();

  useEffect(() => {
    localStorage.setItem('botMessages', JSON.stringify(messages));
  }, [messages]);

  /**
   * Method to update the input message variable when a new input is given to the text area.
   * @param {object} e Click Event.
   */
  const handleInputChange = (e) => {
    setInputMessage(e.target.value);
  };

  /**
   * Method to handle the question inputted by the user and request the API the response.
   */
  const handleSubmit = async () => {
    if (inputMessage) {
      setIsSubmitButtonDisabled(true);
      const userMessageObj = {
        text: inputMessage,
        position: 'right',
        type: 'text',
        date: new Date(),
        avatar: userAvatar,
      };
      setMessages([...messages, userMessageObj]);
      setInputMessage('');
      let answer;
      try {
        const data = await getAnswer(inputMessage);
        answer = data.answer;
      } catch (error) {
        console.error('Error fetching bot answer:', error);
        answer = defaultErrorAnswer;
      }
      setMessages([
        ...messages,
        userMessageObj,
        {
          text: answer,
          position: 'left',
          type: 'text',
          date: new Date(),
          avatar: botAvatar,
        },
      ]);
      setIsSubmitButtonDisabled(false);
    }
  };

  const onKeyDownTextArea = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit();
    }
  };

  const handleClearButtonPressed = () => {
    setMessages([]);
    setInputMessage('');
    localStorage.removeItem('nutriBotMessages');
  };

  return (
    <Layout
      style={{
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
      }}>
      {messages.length > 0 ? (
        <Tooltip title="Apagar">
          <Button
            onClick={handleClearButtonPressed}
            disabled={isSubmitButtonDisabled}
            icon={<DeleteOutlined style={{ fontSize: '1.5em' }} />}
            size="large"
            style={{
              height: 'auto',
              marginLeft: '8px',
              borderRadius: '8px',
              backgroundColor: 'rgb(0, 0, 0)',
              border: 'none',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            }}
          />
        </Tooltip>
      ) : (
        <Layout
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}>
          <Image src={botAvatar} width={50} height={50} />
          <Title level={4} style={{ marginLeft: '16px' }}>
            Envie uma mensagem para falar com o NutriBot
          </Title>
        </Layout>
      )}
      <Content
        style={{
          flex: 1,
          backgroundColor: document.body.style.backgroundColor,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column-reverse',
          paddingBottom: '24px',
        }}>
        <MessageList
          referance={messageListReferance}
          className={styles['message-list']}
          lockable={true}
          toBottomHeight={'100%'}
          dataSource={messages}
        />
      </Content>
      <div
        className={styles['input-container']}
        style={{
          paddingTop: '24px',
          paddingBottom: '24px',
          position: 'fixed',
          width: '95%',
          bottom: 0,
          backgroundColor: document.body.style.backgroundColor,
        }}>
        <Space.Compact style={{ width: '100%' }}>
          <TextArea
            rows={4}
            value={inputMessage}
            onChange={handleInputChange}
            placeholder={insertTextPlaceholder}
            disabled={isSubmitButtonDisabled}
            variant="filled"
            autoSize={{ minRows: 3, maxRows: 5 }}
            style={{
              borderRadius: '8px',
              border: '1px solid #d9d9d9',
              fontSize: '16px',
              lineHeight: '1.5',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            }}
            onKeyDown={onKeyDownTextArea}
          />
          <Tooltip title="Enviar">
            <Button
              onClick={handleSubmit}
              disabled={isSubmitButtonDisabled}
              icon={<SendOutlined style={{ fontSize: '1.5em' }} />}
              size="large"
              style={{
                height: 'auto',
                marginLeft: '8px',
                borderRadius: '8px',
                backgroundColor: 'rgb(253, 0, 126)',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              }}
            />
          </Tooltip>
        </Space.Compact>
      </div>
    </Layout>
  );
};

export default NutriBot;
